<template>
    <v-container class="app-page-container">    
                <v-card class="shadow-none app-page-card">
                   
                <v-card-text>
                     <v-layout class="d-flex border-b mb-4 flex-row vertically-horizontally-centered fill-height">
                        <v-flex class="py-3">
                            <h2 class="color--high-emphasis mb-1">{{info.title}}</h2>
                            <span>{{info.description}}</span>
                            <div v-html="info.description_detail"></div>
                        </v-flex>
                        <v-btn small class="ml-auto px-4 py-4 border-radius-lg btn-primary shadow-none" @click="startCourse()">Start course</v-btn>
                    </v-layout>

                    <v-expansion-panels v-model="panel" flat multiple>
                        <v-expansion-panel>
                            <v-expansion-panel-header class="color--high-emphasis">
                                <span ><b>Course content</b></span>
                                <!-- <span v-if="!contentPopulated">Show content</span> -->
                            </v-expansion-panel-header>

                            <v-expansion-panel-content>

                                <v-expansion-panels flat multiple>
                                    <v-expansion-panel v-for="(chapter) in info.chapterlist" v-bind:key="chapter.chapter_id">
                                        <v-expansion-panel-header class="color--high-emphasis">
                                            {{chapter.name}} ({{chapter.lessons.length}} lessons)
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <ul> 
                                                <li v-for="(lesson) in chapter.lessons" v-bind:key="lesson.lesson_id" >
                                                    {{lesson.lesson}} ({{lesson.tasks}} tasks / {{lesson.programs}} programs)
                                                </li>
                                            </ul>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>

                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-card-text>
            </v-card>
    </v-container>
</template>

<script>
import axios from '../../axios-auth.js'

export default {
    data() {
        return {
            panel: [0],
            info : [],
            populated: 0,
            contentPopulated: false
        }
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.$store.commit('setFeedback', null)    

            // get category list
            axios.get('/course-preview/' + this.$route.params.id, this.$store.getters.getAxiosConfig)
                .then(res => {
                    this.info = res.data 
                    const bc = [
                        { text: res.data.category.name, href: '/areas/' + res.data.category.id },//#
                        { text: res.data.area.name, href: '/courses/' + res.data.area.id },//#      
                        { text: res.data.course.name, href: '/course_preview/' + res.data.course.id },//#
                    ]
                    this.$store.commit('setBreadCrumbs',bc)   
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)
                })
        },
        startCourse() {            
            this.$store.commit('setFeedback', null)    
            // get category list
            axios.post('/write-user-course/' + this.$route.params.id, null, this.$store.getters.getAxiosConfig)
                .then(() => {
                    // open course
                    this.$router.push({name:'course_content', params: {id: this.$route.params.id}})   
                    ///////////////////////////////////////////////////////////////////////
                })
                .catch(error => {
                    // console.log(error.message)
                    this.$store.commit('setFeedback', error)
                })
        },        
    }
}
</script>


<style>

</style>
